import Newborn from "../../../entities/Newborn/ui/Newborn";

const NewbornPage = () => {
    return (  
        <main>
            <Newborn/>
        </main>
    );
}
 
export default NewbornPage;